'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _redux = require('redux');

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

var _tabs = require('./tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _navi = require('./navi');

var _navi2 = _interopRequireDefault(_navi);

var _profile = require('./profile');

var _profile2 = _interopRequireDefault(_profile);

var _datagridDefaultState = require('./datagridDefaultState');

var _datagridDefaultState2 = _interopRequireDefault(_datagridDefaultState);

var _reactisModal = require('reactis-modal');

var _datagridTab = require('./datagridTab');

var _formTab = require('./formTab');

exports['default'] = _redux.combineReducers({
	auth: _auth2['default'],
	navi: _navi2['default'],
	forms: _formTab.reducer,
	datagrids: _datagridTab.reducer,
	tabs: _tabs2['default'],
	modals: _reactisModal.reducer,
	profile: _profile2['default'],
	datagridDefaultState: _datagridDefaultState2['default']
});
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/reducer.js
 ** module id = 1060
 ** module chunks = 2
 **/